import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-blue-600 text-white" id="contact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center">
              <span className="text-2xl font-bold text-white">Ceremonzy</span>
            </div>
            <p className="text-sm text-gray-200">
              Vasai's most trusted ceremony vendor marketplace. Find verified vendors for your perfect ceremony day.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-blue-200">Quick Links</h3>
            <div className="space-y-2">
              <Link to="/" className="block text-gray-200 hover:text-white transition-colors">Home</Link>
              <Link to="/about" className="block text-gray-200 hover:text-white transition-colors">About</Link>
              <Link to="/register-vendor" className="block text-gray-200 hover:text-white transition-colors">List Your Business</Link>
            </div>
          </div>

          {/* Vendor Categories */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-blue-200">Popular Categories</h3>
            <div className="space-y-2">
              <Link to="/category/catering-services" className="block text-gray-200 hover:text-white transition-colors">Catering Services</Link>
              <Link to="/category/decorators" className="block text-gray-200 hover:text-white transition-colors">Decorators</Link>
              <Link to="/category/bands-banjo" className="block text-gray-200 hover:text-white transition-colors">Bands & Banjo</Link>
              <Link to="/category/photographers-content-creators" className="block text-gray-200 hover:text-white transition-colors">Photographers & Content Creators</Link>
              <Link to="/category/makeup-artists" className="block text-gray-200 hover:text-white transition-colors">Makeup Artists</Link>
              <Link to="/category/venues" className="block text-gray-200 hover:text-white transition-colors">Venues</Link>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-blue-200">Contact Info</h3>
            <div className="space-y-2 text-gray-200">
              <div className="flex items-center space-x-2">
                <svg className="w-4 h-4 text-blue-200" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                <span className="text-sm">Vasai-Virar, Maharashtra, India</span>
              </div>
              <a href="tel:+919175192607" className="flex items-center space-x-2 hover:underline hover:text-white transition-colors">
                <svg className="w-4 h-4 text-blue-200" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                <span className="text-sm font-semibold">+91 91751 92607 - Click to Call</span>
              </a>
              <a href="mailto:ceremonzy07@gmail.com" className="flex items-center space-x-2 hover:underline hover:text-white transition-colors">
                <svg className="w-4 h-4 text-blue-200" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                <span className="text-sm">ceremonzy07@gmail.com</span>
              </a>
              <a href="https://www.instagram.com/ceremonzy?igsh=emlmZzFqcm80enFt" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 hover:underline hover:text-white transition-colors">
                <svg className="w-4 h-4 text-blue-200" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
                <span className="text-sm">@ceremonzy</span>
              </a>
            </div>
          </div>

          {/* Legal Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-blue-200">Legal</h3>
            <div className="space-y-2">
              <Link to="/terms-of-use" className="block text-gray-200 hover:text-white transition-colors">Terms of Use</Link>
              <Link to="/privacy-policy" className="block text-gray-200 hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/grievance-policy" className="block text-gray-200 hover:text-white transition-colors">Grievance Policy</Link>
            </div>
          </div>
        </div>

        {/* Safe Harbor Disclaimer */}
        <div className="border-t border-blue-300 mt-8 pt-6">
          <div className="bg-blue-700 rounded-lg p-4 mb-4">
            <p className="text-sm text-blue-100">
              <strong>Disclaimer:</strong> Ceremonzy operates as an intermediary platform under the Information Technology Act, 2000. 
              All reviews, ratings, and user-generated content reflect individual opinions and experiences. We do not endorse or 
              guarantee the accuracy of user-submitted content. Users are responsible for their own content and interactions.
            </p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-blue-300 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-200">
            © 2025 Ceremonzy. All rights reserved. | Compliant with IT Act 2000 & IT Rules 2021
          </p>
          <div className="mt-4 md:mt-0">
            <Link to="/grievance-policy" className="text-sm text-blue-200 hover:text-white underline">
              Report Content Issues
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;